export class DeleteProjectCompanyQuery {
  query = ({ companyId, projectId }: { companyId: number, projectId: number }) => ({
    url: `projects/${projectId}/companies/${companyId}`,
    method: 'DELETE'
  })
}